import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";



const HireReport_log_book = () => {
  useAuthRedirect();
  const { id, branch } = useParams();
  const currentYear = new Date().getFullYear();
  const startYear = 2007;
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [monthlyHours, setMonthlyHours] = useState([])
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true);

  const canView  = hasPermission("Vehicle Log Book", "view");


  useEffect(() => {
    const fetchMonthly = async () => {
      setLoading(true); 
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/log_book_report_hire_1?year=${selectedYear}&id=${id}`
        );
        setMonthlyHours(response.data.monthlyData);
        console.log(response.data.monthlyData);
      } catch (error) {
        console.error("Error fetching monthly data:", error);
      } finally {
        setLoading(false); 
      }
    };
  
    fetchMonthly();
  }, [selectedYear, id]);
  
  const fetchData = async () => {
  
    try {
      const response = await axios.get(
        "https://rfs2.infraconsoft.net.in/api/log_book_report_hire_2",
        {
          params: {
            year: selectedYear,
            id: id,
          },
        }
      );

      const responseData = response.data.logBookReport;
    //   console.log(response.data.logBookReport);
      setData(responseData);
    } catch (error) {
      console.error("Error fetching logBookReport:", error);
    } 
  };

    useEffect(() => {
      fetchData();
    }, [selectedYear, id]);
  

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
            <div className="back-div">
                                            <h2 className="add-txt">Hire Vehicle-Reports</h2>
                                            <Link to={`/vehicle_logbook_list_hire`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                                            </div>
          <Time />
        </section>


        {/* Month & Year Selection */}
        <div className="month-year-container">
          <p className="title">Select your Year:</p>

          <div className="select-container">
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(currentYear - startYear + 1).keys()].map((i) => (
                <option key={startYear + i} value={startYear + i}>
                  {startYear + i}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="content-table">
        <table>
  <thead>
    <tr>
      <th>S.No</th>
      <th>Description</th>
      <th>APR</th>
      <th>MAY</th>
      <th>JUN</th>
      <th>JUL</th>
      <th>AUG</th>
      <th>SEP</th>
      <th>OCT</th>
      <th>NOV</th>
      <th>DEC</th>
      <th>JAN</th>
      <th>FEB</th>
      <th>MAR</th>
    </tr>
  </thead>
  <tbody>
  {loading ? (
    <tr>
      <td colSpan="14" align="center">Loading...Please Wait</td>
    </tr>
  ) : monthlyHours.length > 0 ? (
    <>
      <tr>
        <td>1.</td>
        <td>Vehicle monthly working hours</td>
        {monthlyHours.map((m, i) => (
          <td key={i} align="center">{m.totalHrs}</td>
        ))}
      </tr>

      <tr>
        <td>2.</td>
        <td>Vehicle monthly working Kilometers</td>
        {monthlyHours.map((m, i) => (
          <td key={i} align="center">{m.totalKm}</td>
        ))}
      </tr>

      <tr>
        <td>3.</td>
        <td>Vehicle monthly Diesel issues</td>
        {monthlyHours.map((m, i) => (
          <td key={i} align="center">{m.totalDieselHours}</td>
        ))}
      </tr>

      <tr>
        <td>4.</td>
        <td>Diesel Basic Rate per Unit</td>
        {data.map((m, i) => (
          <td key={i} align="center">{m.avgDieselRate !== null ? m.avgDieselRate : '-'}</td>
        ))}
      </tr>

      {/* 5. Vehicle monthly Diesel Cost */}
<tr>
  <td>5.</td>
  <td>Vehicle monthly Diesel Cost</td>
  {data.map((m, i) => (
    <td key={i} align="center">
      {m.totalDieselCost === null || m.totalDieselCost === 0 ? "-" : m.totalDieselCost}
    </td>
  ))}
</tr>

      <tr>
        <td>6.</td>
        <td>Monthly diesel consumption (hour/diesel)</td>
        {data.map((m, i) => (
          <td key={i} align="center">{m.dieselconsumHr !== null ? m.dieselconsumHr : '-'}</td>
        ))}
      </tr>

      <tr>
        <td>7.</td>
        <td>Monthly diesel consumption (km/diesel)</td>
        {data.map((m, i) => (
          <td key={i} align="center">{m.dieselconsumKm !== null ? m.dieselconsumKm : '-'}</td>
        ))}
      </tr>

      <tr>
        <td>8.</td>
        <td>Diesel Cost / Hour</td>
        {data.map((m, i) => (
          <td key={i} align="center">{m.costHr !== null ? m.costHr : '-'}</td>
        ))}
      </tr>

      <tr>
        <td>9.</td>
        <td>Diesel Cost / KM</td>
        {data.map((m, i) => (
          <td key={i} align="center">{m.costKm !== null ? m.costKm : '-'}</td>
        ))}
      </tr>
    </>
  ) : (
    <tr>
      <td colSpan="14" align="center">No Data Available</td>
    </tr>
  )}
</tbody>

</table>

        </div>
      </div>
    </div>
  );
};

export default HireReport_log_book;
